const openButton = document.querySelector('.Header-Mobile__Button-Open');
const closeButton = document.querySelector('.Header-Mobile__Button-Close');
const nav = document.querySelector('.Header-Mobile__Nav');
const navBackground = document.querySelector('.Header-Mobile__Nav-Background');

openButton.addEventListener('click', () => {
  nav.classList.add('Header-Mobile__Nav--Active');
  navBackground.classList.add('Header-Mobile__Nav-Background--Active');
});
closeButton.addEventListener('click', () => {
  nav.classList.remove('Header-Mobile__Nav--Active');
  navBackground.classList.remove('Header-Mobile__Nav-Background--Active');
});

const desktopButtons = document.querySelectorAll('.Header__Link--Dropdown')
const desktopOverlays = document.querySelectorAll('.Header-Link-Overlay')
const desktopButtonsIsOpen = []

const mobileItem = document.querySelectorAll('.Header-Mobile__Link-List')
const mobileLists = document.querySelectorAll('.Header-Mobile__List')
const mobileButtons = document.querySelectorAll('.Header-Mobile__Link-Button')
const mobileButtonIcons = document.querySelectorAll('.Header-Mobile__Link-Button .lucide-plus')
const mobileButtonsIsOpen = []

mobileButtons.forEach(item => mobileButtonsIsOpen.push(false))

mobileItem.forEach((item, index) => {
  mobileButtons[index].addEventListener('click', (e) => {
    e.stopPropagation()
    e.preventDefault()
    const icon = mobileButtonIcons[index]

    if(!mobileButtonsIsOpen[index]) {
      mobileLists[index].classList.remove('d-none')

      mobileLists[index].animate([
        { height: '0px'},
        { height: '100%' }
      ], {
        duration: 200,
        fill: 'forwards'
      })

      mobileButtonsIsOpen[index] = true
      icon.classList.remove('lucide-plus')
      icon.classList.add('lucide-minus')
    } else {
      mobileLists[index].animate([
        { height: '100%' },
        { height: '0px' }
      ], {
        duration: 200,
        fill: 'forwards'
      })

      mobileButtonsIsOpen[index] = false
      icon.classList.remove('lucide-minus')
      icon.classList.add('lucide-plus')
      mobileLists[index].classList.add('d-none')
    }
  })
})


desktopButtons.forEach(item => desktopButtonsIsOpen.push(false))

desktopButtons.forEach((item, index) => {
  desktopButtons[index].addEventListener('click', (e) => {
    e.stopPropagation()
    e.preventDefault()

    if(!desktopButtonsIsOpen[index]) {
      desktopOverlays[index].classList.remove('d-none')

      const isOtherOpen = desktopButtonsIsOpen.indexOf(true)

      if(isOtherOpen !== -1) {
        desktopOverlays[isOtherOpen].animate([
          { opacity: 1 },
          { opacity: 0 }
        ], {
          duration: 200,
          fill: 'forwards'
        })

        setTimeout(() => {
          desktopOverlays[isOtherOpen].classList.add('d-none')
          desktopButtonsIsOpen[isOtherOpen] = false
        }, 200)
      }

      desktopOverlays[index].animate([
        { opacity: 0 },
        { opacity: 1 }
      ], {
        duration: 200,
        delay: isOtherOpen ? 300 : 0,
        fill: 'forwards'
      })

      desktopButtonsIsOpen[index] = true
    } else {
      desktopOverlays[index].animate([
        { opacity: 1 },
        { opacity: 0 }
      ], {
        duration: 200,
        fill: 'forwards'
      })

      setTimeout(() => {
        desktopOverlays[index].classList.add('d-none')
        desktopButtonsIsOpen[index] = false
      }, 200)
    }
  })

  window.addEventListener('scroll', (e) => {
    desktopOverlays[index].classList.add('d-none')
    desktopButtonsIsOpen[index] = false

    desktopOverlays[index].animate([
      { opacity: 1 },
      { opacity: 0 }
    ], {
      duration: 200,
      fill: 'forwards'
    })
  })

})
// const header = document.querySelector('.Header')
// const linkOpenList = document.getElementById('link-open-list')
// const headerLinkList = document.getElementById('link-list')
// let isShowHeaderLinkList = false

// linkOpenList.addEventListener('mouseenter', () => {
//   headerLinkList.animate([
//     { opacity: 0 },
//     { opacity: 1 }
//   ], {
//     duration: 300,
//     fill: 'forwards'
//   })

//   isShowHeaderLinkList = true
// })

// header.addEventListener('mouseleave', () => {
//   setTimeout(() => {
//     if(isShowHeaderLinkList) {
//       headerLinkList.animate([
//         { opacity: 1 },
//         { opacity: 0 }
//       ], {
//         duration: 300,
//         fill: 'forwards'
//       })

//       isShowHeaderLinkList = false
//     }
//   }, 500)
// })